import { lazy } from "react";

export const UsersPage = lazy(() => import("./usersPage"));
